module.exports = __webpack_public_path__ + "media/images/icons/phone-1ab8327f1f887fb75570338d3d208e8e.svg";